import { render, staticRenderFns } from "./VariantForm.vue?vue&type=template&id=3ab0f5c6&scoped=true"
import script from "./VariantForm.vue?vue&type=script&lang=js"
export * from "./VariantForm.vue?vue&type=script&lang=js"
import style0 from "./VariantForm.vue?vue&type=style&index=0&id=3ab0f5c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab0f5c6",
  null
  
)

export default component.exports